// @flow
import * as React from "react";

import AffiliateBalance from "./AffiliateBalance";
import SearchBar from "./SearchBar";
import ThemeToggle from "./ThemeToggle";
import UserMenu from "./UserMenu";

type Props = {
  children: React.Node,
};

function List({ children }: Props): React.Node {
  return (
    <ul className="navbar-nav ms-auto align-items-center">
      <ThemeToggle />
      {children}
      <UserMenu />
    </ul>
  );
}

function Manager(): React.Node {
  return (
    <List>
      <SearchBar />
    </List>
  );
}

function Affiliate(): React.Node {
  return (
    <List>
      <AffiliateBalance />
    </List>
  );
}

export default {
  Manager,
  Affiliate,
};
